import * as sdk from './importShareSDK'
import env from '../core/env'
import query from '../util/query'
import { wx, alipayMp } from './exposeApi'

const urlQuery = Object.assign({}, query.query(), query.hashQuery())

let isMiniAppEnv = false

let miniAppShare = function (miniAppConfig) {
  let wxReady = function () {
    // 这里是微信只判断一次
    if (window.__wxjs_environment === 'miniprogram') {
      // 小程序环境
      isMiniAppEnv = true
      if (urlQuery.from === 'xwebapp') {
        window.wx && window.wx.miniProgram.postMessage({
          data: {
            type: miniAppConfig.type,
            data: miniAppConfig.data
          }
        })
      } else {
        delete miniAppConfig.data
        window.wx && window.wx.miniProgram.postMessage({
          data: miniAppConfig
        })
      }
    }
  }
  // use shareSDK wx ready 接口 简化判断
  wx(function () {
    wxReady()
  })
}

let alipayMiniAppShare = function (miniAppConfig) {
  let alipayMpReady = function () {
    window.my && window.my.getEnv(function (res) {
      isMiniAppEnv = res.miniprogram || false
      window.my.postMessage({
        data: miniAppConfig
      })
    })
  }
  alipayMp(function () {
    alipayMpReady()
  })
}

export function setShareOutApp (cfg) {
  // 这里先setShare一下把jssdk加载进来才能有window.wx, 后期再覆盖配置
  sdk.setShare(cfg)
  if (cfg.type && cfg.type === 'miniApp') {
    // 小程序内webview二次分享
    let path
    // 如果传了path 则使用页面的path
    if (cfg.ext && cfg.ext.path) {
      path = cfg.ext.path
    } else {
      path = `/pages/webview-page/index?url=${window.encodeURIComponent(window.location.href)}`
    }

    const miniAppConfig = {
      path,
      title: cfg.title,
      type: 'share', // 霸王花乘客小程序需要用type作为区分这个message是做什么的
      imageUrl: cfg.shareCardIcon,
      data: {
        title: cfg.title,
        imageUrl: cfg.shareCardIcon,
        url: cfg.url || window.location.href
      }
    }
    miniAppShare(miniAppConfig)

    if (env.is('alipay.miniprogram')) {
      alipayMiniAppShare(miniAppConfig)
    }
  }
}

export function invokeShareOutApp (channel, opt) {
  if (channel === 'weixin_appmsg' || channel === 'weixin_timeline') {
    channel = 'wechat'
  }
  const cfg = Object.assign({}, opt, {
    url: opt.url,
    platform: channel,
    isMiniAppEnv
  })
  if (isMiniAppEnv) {
    // 小程序内h5调起分享展示弹窗
    sdk.showShareShadow(cfg)
  } else {
    sdk.invokeShare(cfg)
  }
}
